export const validEmail = (email: string): boolean =>
  typeof email === 'string' &&  /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9åäöÅÄÖ.-]+\.[a-zA-Z]{2,}$/.test(email);

export const validUserName = (userName: string) =>
  typeof userName === 'string' && /^[a-zA-Z0-9\\-\\ ._@+]{5,50}$/.test(userName);

export const validDomain = (domain: string): boolean =>
  typeof domain === 'string' && /^[a-zA-Z0-9åäöÅÄÖ.-]+\.[a-zA-Z]{2,}$/.test(domain);

export const isBetween = (min: number, max: number, str: string): boolean => 
  typeof str === 'string' && str.length >= min && str.length <= max;

export const isGreaterThan = (num: number, str: string): boolean =>
  typeof str === 'string' && str.length > num;

export const isLessThan = (num: number, str: string): boolean =>
  typeof str === 'string' && str.length < num;

export const validPassword = (password: string, username: string) => {
  
  let message = '';

  const validPassword = /\S{8,100}/.test(password) 
      && /[A-ZÅÄÖ]/.test(password) 
        && /[a-zåäö]/.test(password) 
          && /[0-9]/.test(password) 
            && !password.includes(username);

  return typeof password === 'string' && validPassword;
}
